<script lang="ts">
	import { format } from 'svelte-i18n';
	import { push, querystring } from 'svelte-spa-router';

	import LinkingProcessStartShelly from '../components/Integrations/AlexaAppLinking/LinkingProcessStartShelly.svelte';
	import LinkingProcessStartAlexa from '../components/Integrations/AlexaAppLinking/LinkingProcessStartAlexa.svelte';
	import AppToAppAlexa from './AppToAppAlexa.svelte';

	import { Toolbar, Breadcrumbs } from '@Shelly/shelly-design-system';

	import { parseQuerystring } from 'src/helpers/utilities';
	import { normalizeAlexaQuery } from 'src/helpers/alexa_app_linking_helpers';
	import { pendingAlexaQuery } from 'src/helpers/alexa_app_linking_navigation';

	$: parsed = parseQuerystring($querystring || '');
	$: code = parsed.code;
	$: error = parsed.error;
	$: client_id = parsed.client_id;
	$: state = parsed.state;
	$: redirect_uri = parsed.redirect_uri;
	$: response_type = parsed.response_type;
	$: scope = parsed.scope;

	$: params = {
		client_id,
		state,
		redirect_uri,
		response_type,
		scope,
	};

	$: if (
		$pendingAlexaQuery !== null &&
		normalizeAlexaQuery($querystring || '') === $pendingAlexaQuery
	) {
		pendingAlexaQuery.set(null);
	}
</script>

<Toolbar class="mb-m">
	<Breadcrumbs
		aria-label={$format('label_amazon_alexa', { default: 'Amazon Alexa' })}
		slot="breadcrumbs"
		links={[
			{ label: 'Integrations', onClick: () => push('/settings/integrations') },
			{ label: 'Amazon Alexa' },
		]}
	/>
</Toolbar>

{#if code || error}
	{#key $querystring}
		<AppToAppAlexa />
	{/key}
{:else if client_id && state && redirect_uri}
	<LinkingProcessStartAlexa {...params} />
{:else}
	<LinkingProcessStartShelly bottomMargin />
{/if}
